/* eslint-disable no-plusplus */
import React, { useRef, useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { format } from 'date-fns';
import ptBR from 'date-fns/locale/pt-BR';

import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import { useHistory } from 'react-router-dom';
import { useToast } from '../../../../hooks/toast';

import { Container, Content, ContentArea, FormContainer } from './styles';

import api from '../../../../services/api';

import LeftMenu from '../../../../components/LeftMenu';
import InputWithLabel from '../../../../components/InputWithLabel';
import TextArea from '../../../../components/TextArea';
import Button from '../../../../components/Button';

interface MyInssFormData {
  attendance_date: string;
  folder: string;
  description: string;
}

interface Client {
  id: string;
  name: string;
}

interface ClientProcess {
  id: string;
  process_number: string;
  folder: string;
  client: Client;
  attendance_type_id: string;
}

interface Location {
  id: string;
  client: Client;
  client_process: ClientProcess;
  process_attendance_id: string;
  der: string;
}

interface ProcessAttendance {
  clientProcess: ClientProcess;
}

const FinishMyinss: React.FC = () => {
  const history = useHistory();
  const location = useLocation();

  const [clientProcess, setClientProcess] = useState<ClientProcess>();

  const locationState: Location = location.state as Location;

  console.log('Location', location);

  const formRef = useRef<FormHandles>(null);
  const { addToast } = useToast();

  useEffect(() => {
    if (locationState) {
      setClientProcess(locationState.client_process);
      formRef.current?.setData({ folder: locationState.client_process.folder });
      formRef.current?.setData({ attendance_date: locationState.der });
    }
  }, [locationState]);

  console.log('client process', clientProcess);

  const handleSubmit = useCallback(
    async (data: MyInssFormData) => {
      try {
        // console.log(attendanceType);
        // console.log(clientProcess);

        if (clientProcess) {
          await api.put('/process-attendance', {
            id: locationState.process_attendance_id,
            client_id: locationState.client.id,
            attendance_type_id: 'e786cca0-201a-4e6c-b5c7-2575bcedc178',
            client_process_id: clientProcess?.id,
            description: data.description,
            attendance_date: data.attendance_date,
          });

          await api.put('/myinss-list', {
            id: locationState.id,
            client_id: locationState.client.id,
            client_process_id: clientProcess?.id,
            der: data.attendance_date,
            done: true,
          });

          /**
           * Após atualizar o andamento do processo e dar o ítem da lista como concluído, um andamento meu inss concluído deve ser criado
           */

          await api.post('/process-attendance', {
            client_id: locationState.client.id,
            attendance_type_id: 'e11dcf56-acd8-45a1-b572-9cbce7c89da0',
            client_process_id: clientProcess?.id,
            description: '',
            attendance_date: format(new Date(), " yyyy'-'MM'-'dd", {
              locale: ptBR,
            }),
          });

          history.push('/myinss-list');

          addToast({
            type: 'success',
            title: 'Lista finalizada!',
            description: 'Lista de meu INSS finalizada',
          });
        }
      } catch (err) {
        addToast({
          type: 'error',
          title: 'Erro ao finalizar lista de meu INSS',
          description: 'Ocorreu um erro ao finalizar lista de meu INSS.',
        });
      }
    },
    [
      addToast,
      clientProcess,
      history,
      locationState.client.id,
      locationState.id,
      locationState.process_attendance_id,
    ],
  );

  return (
    <Container>
      <Content>
        <LeftMenu />
        <ContentArea>
          <h1>Meu INSS</h1>

          <Form ref={formRef} onSubmit={handleSubmit}>
            <FormContainer>
              <InputWithLabel name="folder" label="Pasta" type="text" />

              <label>
                {clientProcess && clientProcess?.client.name}{' '}
                {clientProcess && ' - Processo: '}
                {clientProcess && clientProcess.process_number}
              </label>
            </FormContainer>

            <FormContainer>
              <InputWithLabel name="attendance_date" label="Data" type="date" />
            </FormContainer>

            <FormContainer>
              <TextArea
                name="description"
                label="Histórico"
                rows={3}
                cols={100}
              />
            </FormContainer>

            <Button type="submit">Salvar</Button>
          </Form>
        </ContentArea>
      </Content>
    </Container>
  );
};

export default FinishMyinss;
